import React, { useState, useRef, useEffect } from 'react';
import Form, {
    Item,
    Label,
    ButtonItem,
    ButtonOptions,
    GroupItem
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useAuth } from '../../contexts/auth';
import axios from 'axios';
import { backendlink } from '../../config';
import { Toast } from 'devextreme-react/toast';
import GroupCaption from "../../pages/group-caption/GroupCaption";

export default function PartnerCustomerAddForm() {
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);
  const [formData, setformData] = useState({
    id: "",
    companyname: "",
    companyaddress: "",
    contactperson: "",
    email: "",
    phone: "",
    loginEmail: "",
  });
  const formDataRef = useRef(null);

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "success",
    message: "",
  });

  const groupCaptionNamedRender = (iconName) => {
    const groupCaptionRender = (data) => (
      <GroupCaption iconName={iconName} {...data} />
    );
    return groupCaptionRender;
  };

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(formData.email)) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "error",
        message: "Email format error",
      });
    } else if (!validateEmail(formData.loginEmail)) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "error",
        message: "Login Email format error",
      });
    } else {
      setLoading(true);

      try {
        const response = await axios
          .post(
            backendlink + "partner/createcustomer",
            {
              usertoken: user.userToken,
              username: formData.loginEmail,
              password: formData.password,
              confirmPassword: formData.confirmPassword,
              companyname: formData.companyname,
              companyaddress: formData.companyaddress,
              contactperson: formData.contactperson,
              email: formData.email,
              phone: formData.phone,
            },
            {
              headers: {
                token: user.token,
              },
            }
          )
          .then((res) => {
            setLoading(false);

            if (res.data.errorno == 0) {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: "success",
                message: "Organization created",
              });

              setformData({
                id: "",
                companyname: "",
                companyaddress: "",
                contactperson: "",
                email: "",
                phone: "",
                loginEmail: "",
              });
            } else {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: "error",
                message: res.data.errmessage,
              });
            }
          });
      } catch (error) {
        setLoading(false);
        alert(error);
      }
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  useEffect(() => {}, [user]);

  const passwordOptions = { mode: "password" };

  return (
    <form onSubmit={onSubmit}>
      <Form formData={formData} ref={formDataRef} disabled={false} colCount={4}>
        <GroupItem
          iconName="user"
          captionRender={groupCaptionNamedRender("user")}
          caption="Personal Information"
          colSpan={4}
        >
          <GroupItem colCount={2}>
            <Item dataField={"companyname"} editorType={"dxTextBox"}>
              <Label text="Organization Name" />
            </Item>

            <Item dataField={"companyaddress"} editorType={"dxTextBox"}>
              <Label text="Address" />
            </Item>
          </GroupItem>
        </GroupItem>

        <GroupItem
          captionRender={groupCaptionNamedRender("card")}
          caption="Login Details"
          colSpan={2}
        >
          <Item dataField={"loginEmail"} editorType={"dxTextBox"}>
            <Label text="Login Email" />
          </Item>

          <GroupItem colCount={2}>
            <Item
              colSpan={1}
              dataField={"password"}
              editorType={"dxTextBox"}
              editorOptions={passwordOptions}
            >
              <Label text="Password" />
            </Item>

            <Item
              colSpan={1}
              dataField={"confirmPassword"}
              editorType={"dxTextBox"}
              editorOptions={passwordOptions}
            >
              <Label text="Confirm Password" />
            </Item>
          </GroupItem>
        </GroupItem>

        <GroupItem
          captionRender={groupCaptionNamedRender("home")}
          caption="Emergency Contact"
          colSpan={2}
        >
          <GroupItem colCount={1}>
            <Item dataField={"contactperson"} editorType={"dxTextBox"}>
              <Label text="Contact Person" />
            </Item>

            <Item dataField={"phone"} editorType={"dxTextBox"}>
              <Label text="Contact Number" />
            </Item>

            <Item dataField={"email"} editorType={"dxTextBox"}>
              <Label text="Contact Email" />
            </Item>
          </GroupItem>
        </GroupItem>

        <ButtonItem colSpan={4} cssClass="full-width-button">
          <ButtonOptions
            width={"100%"}
            type={"default"}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width={"24px"} height={"24px"} visible={true} />
              ) : (
                "Add New Organization"
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
      </Form>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </form>
  );
}